import { BsEnvelope, BsTrash3 } from "react-icons/bs";
import { GoPencil } from "react-icons/go";
import { LuPhone } from "react-icons/lu";
import { Badge, Card, CardBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import IconButton from "../Buttons/IconButton";

function ContactCard({ data, onEditClick, onDeleteClick }) {
  const { t } = useTranslation();
  return(
    <Card>
      <CardBody>
        <div className="position-absolute top-0 m-2 end-0">
          <IconButton size="sm" outline className="me-2" onClick={onEditClick}>
            <GoPencil size={16} />
          </IconButton>
          <IconButton size="sm" color="danger" outline onClick={onDeleteClick}>
            <BsTrash3 size={16} />
          </IconButton>
        </div>

        <Badge color="primary">{t('common.primary')}</Badge>

        <h6 className="mt-3 mb-2">{data.responsible_name}</h6>

        <p className="mb-1 text-muted small">
          <LuPhone size={16} className="me-2" />
          {data.phone_number}
        </p>
        <p className="mb-0 text-muted small">
          <BsEnvelope size={16} className="me-2" />
          {data.email}
        </p>
      </CardBody>
    </Card>
  );
}

export default ContactCard;